import React from "react";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function TextBlockSkeleton({ srMessage }) {
  return (
    <div role="status" className="content-box-skeleton">
      { srMessage && (
        <span className="sr-only">
          {srMessage}
        </span>
      )}
      <Skeleton height={180} containerClassName="w-100" count={1} />
    </div>
  );
}

export default TextBlockSkeleton;
